var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import AnimateHeight from 'react-animate-height';
import { AnalyticsTrigger } from '@core-front/analytics';
import PropsChecker from '@core-front/props-checker';
export const TabsContext = React.createContext({
    currentTab: '',
    setCurrentTab: /* istanbul ignore next */ () => null,
});
function BEM(props) {
    const classArray = ['tabs'];
    if (props.align) {
        classArray.push('tabs--' + props.align);
    }
    if (props.border) {
        classArray.push('tabs--border-' + props.border);
    }
    if (props.className) {
        classArray.push(props.className);
    }
    return classArray.join(' ');
}
const TabsCore = (props) => {
    const getContent = () => {
        if (props.disableAnalyticsTrigger) {
            return React.createElement(TabsCoreInner, Object.assign({}, props));
        }
        return (React.createElement(AnalyticsTrigger, { trigger: {
                callback: 'onTabChange',
                id: ([, nextTab]) => `Tabs - ${nextTab}`,
                elementId: ([, nextTab]) => `${nextTab}`,
                elementType: 'tab',
                interactionType: 'open',
            } },
            React.createElement(TabsCoreInner, Object.assign({}, props))));
    };
    return (React.createElement(PropsChecker, { componentProps: props, componentName: "Tabs", defaultValueName: "defaultCurrentTab", valueName: "currentTab", onChangeNames: "onTabChange" }, getContent()));
};
const TabsCoreInner = (props) => {
    const { TabsItem, TabsNav } = props.components;
    const [innerCurrentTab, setInnerCurrentTab] = React.useState(props.defaultCurrentTab || '');
    const [height, setHeight] = React.useState('auto');
    const [heightOnAnimationEnd, setHeightOnAnimationEnd] = React.useState(0);
    const isCurrentTabControlled = (tab = props.currentTab) => {
        return !!props.onTabChange && typeof tab !== 'undefined';
    };
    const currentTab = isCurrentTabControlled(props.currentTab) ? props.currentTab : innerCurrentTab;
    const setCurrentTab = (id) => {
        if (id === currentTab) {
            return;
        }
        Promise.resolve()
            .then(() => setHeight(heightOnAnimationEnd))
            .then(() => {
            if (currentTab !== id) {
                if (!isCurrentTabControlled()) {
                    setInnerCurrentTab(id);
                }
                if (props.onTabChange) {
                    props.onTabChange(currentTab, id);
                }
                setHeight('auto');
            }
        });
    };
    const getNavItems = () => {
        return React.Children.toArray(props.children).filter((child) => {
            return React.isValidElement(child) && (child.type === TabsItem || child.type === props.itemComponent);
        }).map((item) => {
            const _a = item.props, { children, label, id } = _a, rest = __rest(_a, ["children", "label", "id"]);
            return Object.assign(Object.assign({}, rest), { 'id': `${id}-nav-item`, 'current': currentTab === id, 'onClick': () => setCurrentTab(id), 'text': label, 'url': `#${id}`, 'aria-controls': id, 'aria-label': label });
        });
    };
    return (React.createElement(TabsContext.Provider, { value: {
            currentTab,
            setCurrentTab,
        } },
        React.createElement("div", { className: BEM(props) },
            React.createElement(TabsNav, { items: getNavItems(), "aria-labelledby": props['aria-labelledby'] }),
            React.createElement(AnimateHeight, { className: "tabs__content", height: height, duration: 300, onHeightAnimationEnd: (newHeight) => setHeightOnAnimationEnd(newHeight), applyInlineTransitions: false, style: { transition: 'height 300ms cubic-bezier(0.22, 0.61, 0.35, 1)' } }, props.children))));
};
export { TabsCore as default, };
